<template>
  <div class="mainWeb">
    <el-dialog title="卡信息"  :visible.sync="dialogVisible" width="1000px">
      <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
        <!-- <el-form-item label="卡的简称" prop="cardShortName">
          <el-input class="w220" v-model="formparams.cardShortName" placeholder="请输入卡名称" maxlength="20"></el-input>
        </el-form-item> -->
        <el-form-item label="微信价格" prop="weChatPrice">
        <el-input class="w220" v-model="formparams.weChatPrice" placeholder="请输入卡的价格"></el-input>
        </el-form-item>
        <el-form-item label="出售最大数量" prop="maxSell">
          <el-input-number v-model.number="formparams.maxSell" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="购买最大数量">
          <el-input class="w220" v-model="formparams.canBuyNum" placeholder="请输入购买最大数量"></el-input>
        </el-form-item>
        <el-form-item label="是否支持购买" prop="limit" label-width="140px">
          <!-- isPurchase  0 否  1是 -->
          <el-switch
            v-model="formparams.canntBuy"
            active-value= '0'
            inactive-value= '1'
            active-text="是"
            inactive-text="否">
          </el-switch>
        </el-form-item>
        <el-form-item  label="展示顺序">
          <el-input class="w220" v-model="formparams.showSort" placeholder="请输入展示顺序"></el-input>
        </el-form-item>
        <el-form-item label="卡说明">
          <editor-bar v-model="formparams.description" :isClear="isClear"></editor-bar>
        </el-form-item>
          
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
      </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableDataOn" height="68vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="cardName" label="卡名称"></el-table-column>
          <el-table-column scope="scope" label="卡图片">
          <template slot-scope="scope">
            <img class="imgList" style="width:100px;height:50px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.imgpath" alt="">
          </template>
        </el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{ scope.row.shopNum | caseType }} </div>
          </template>
        </el-table-column>        
        <el-table-column prop="weChatPrice" label="微信价格"></el-table-column>
        <el-table-column prop="maxSell" label="出售最大次数"></el-table-column>
        <el-table-column prop="canBuyNum" label="购买最大数量">
          <template slot-scope="scope">
            <p v-if="scope.row.canBuyNum&&scope.row.canBuyNum > 0">{{scope.row.canBuyNum}}</p>
            <p v-else>未限制</p>
          </template>
        </el-table-column>
        <el-table-column label="卡说明">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="300px">
              <p style="width:300px;" v-html="scope.row.description"></p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">鼠标放上查看说明</el-tag>
              </div>
            </el-popover>
            </template>
        </el-table-column>
        <el-table-column width="300" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button style="width:100px"  type="danger" @click="removeList(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
let that;
import {getCardsSell, cardAvailable, getShops, updateCardsSell, deletetOnlineCard, getCardShopList,getInfCs} from "../../api/configApi";
import EditorBar from '../../components/wangEnduit'
export default {
  props:["tableDataOn","shopNumChild","name"],
  data() {
    return {
      activeName:'offLine',
      loading: false,
      dialogVisible: false,
      showShop:false,
      addType:1,
      isClear:false,
      rules:{
        cardShortName:[
          { required: true, message: '请输入简称', trigger: 'blur' }
        ],
        weChatPrice: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern:/(^[0-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{2}$)/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        subtitle:[{ required:true,message:'请输入票说明',trigger:'blur' }],
        maxSell:[
          { required: true, message: '请输入私教类型'},
          { type:'number',min:1, message: '必选为大于0的数字'}
        ]
      },
      showQuery: false,
      formparams:{
        cardName:'',
        cardShortName:'',
        weChatPrice:'',
        description:'',
        shopNum:'',
        maxSell:'',
        canBuyNum: '',
        canntBuy: '0'
      },
      //分店列表
      shopList:[],
      cardshopList: [],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      shopNum:'',
      params: {
        name:null,
        shopNum:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  beforeCreate(){
    that = this
  },
  created(){
  },
  components:{
    EditorBar,
  },
  mounted() {
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
    }else{
      this.getShopsList()
    }
    if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
      this.params.shopNum = this.shopList[0].shopNum
      this.showShop = false
    } else{
      this.showShop = true
    }
    // this.getShopsList()
    // this.getTableListOff()
  },
  methods: {
     // 查询卡可使用的分店
     getCardShopList(cardShortName) {
      getCardShopList({cardShortName}).then((res)=>{
        this.cardshopList = res.data
        console.log(res)
      })
    },
    //  //查询卡列表
    getTableList(){
      this.params.shopNum = this.shopNumChild
      this.params.name = this.name
      getCardsSell(this.params).then((res)=>{
        if(res.msg=='success'){
          // console.log(this.tableData)
          this.$emit('getTableDataOn',res.data)
          // this.tableDataOn = res.data.info
          // this.total = res.data.total          
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
          this.showShop = false
        }else{
          this.showShop = true
        }
      })
    },
    edit(row){
      this.formparams = row
      if(row.canntBuy) {
        this.formparams.canntBuy = row.canntBuy
      }else {
        this.formparams.canntBuy = '0'
      }
      // this.getCardShopList(row.shortname)
      // this.formparams.shopNum = ''
      this.dialogVisible = true
      this.formparams.weChatPrice = parseFloat(row.weChatPrice)
    },
    //删除卡
    removeList(row){
      // ticketId
      this.$confirm('此操作将删除当前卡, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deletetOnlineCard({shopNum:row.shopNum,cardShortName:row.cardShortName}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'删除成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          cardAvailable({cardShortName:this.formparams.cardShortName,shopNum:this.formparams.shopNum}).then((res)=>{
            if(res.msg == 'success'){
              updateCardsSell(this.formparams).then((res)=>{
                if(res.msg == 'success'){
                  this.getTableList()
                  this.dialogVisible = false
                  this.$message({
                    type:'success',
                    message:'修改成功'
                  })
                } else{
                  this.dialogVisible = true
                  this.$message.error(res.data);
                }
              })
            } else{
              this.$message.error(res.data);
            }
          })
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      if(this.name == 'onLine'){
        this.getTableList()
      }else{
        this.getTableListOff()
      }
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      if(this.name == 'onLine'){
        this.getTableList()
      }else{
        this.getTableListOff()
      }
    },
  }
}
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// onineCard.vue?77a07cb6